var _g, _g2, _path, _path2, _circle, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoyaLagrangniana(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_92_296",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 24,
    height: 25
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_92_296)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.00434 17.6072L14.4129 19.9133L14.5321 17.4833L7.1415 15.4564L6.00434 17.6072ZM15.9771 20.3423L17.0799 20.6448L16.6611 22.1717L2.91857 18.4027L3.33736 16.8757L4.44015 17.1782L10.2082 6.26853C10.3816 5.9405 10.7596 5.77694 11.1174 5.87508L16.0003 7.21427C16.3582 7.31242 16.5998 7.64592 16.5816 8.01653L15.9771 20.3423ZM7.8996 14.0225L14.6116 15.8633L14.7705 12.6233L9.41581 11.1547L7.8996 14.0225ZM10.1739 9.72082L14.8499 11.0033L14.9692 8.57327L11.3111 7.57L10.1739 9.72082Z",
    fill: "currentColor"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_92_296)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.50005 18.5C5.10226 18.4747 7.6883 18.9922 10.5987 18.3559C13.5091 17.7196 16.1457 17.8896 18.5 19L19.5989 18.5007L17.8742 7.33935L9.96127 5.16914L0.331533 15.0753C1.07677 15.5895 2.21828 18.5202 3.50005 18.5Z",
    fill: "currentColor"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0192 5.00094C15.1653 4.46833 14.8519 3.91814 14.3193 3.77206C13.7867 3.62599 13.2365 3.93934 13.0904 4.47196L15.0192 5.00094ZM14.358 7.41191L15.0192 5.00094L13.0904 4.47196L12.4292 6.88292L14.358 7.41191Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0549 4.73651L14.5839 2.80774",
    stroke: "currentColor"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.8483,
    cy: 1.84332,
    r: 1.5,
    transform: "rotate(15.3369 14.8483 1.84332)",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 18.5736C14.8842 18.1634 13.1486 18.3495 11.6915 19.0893C9.72278 20.0889 7.35542 20.2756 5.21675 19.6L2.5114 18.7453C2.11033 18.6186 1.90171 18.2292 2.04543 17.8757C2.18914 17.5221 2.63077 17.3381 3.03184 17.4648L5.73719 18.3195C7.44963 18.8605 9.34518 18.711 10.9215 17.9107C12.7414 16.9867 14.9089 16.7542 16.9269 17.2665L19.4418 17.9049C19.8512 18.0089 20.0876 18.3857 19.9697 18.7466C19.8518 19.1076 19.4243 19.3159 19.0149 19.212L16.5 18.5736Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8119 21.5542C15.7733 21.1421 13.6078 21.3434 11.7029 22.1109C9.31399 23.0734 6.57969 23.2667 4.0474 22.6307L0.556149 21.7539C0.14872 21.6515 -0.0868849 21.2792 0.0299114 20.9223C0.146708 20.5653 0.571676 20.3589 0.979105 20.4612L4.47036 21.3381C6.64496 21.8842 9.00189 21.7191 11.0616 20.8892C13.271 19.999 15.7831 19.764 18.157 20.244L21.405 20.9006C21.818 20.9841 22.0755 21.3451 21.9802 21.707C21.8849 22.0688 21.4728 22.2944 21.0598 22.2109L17.8119 21.5542Z",
    fill: "currentColor"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_92_296"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white",
    transform: "translate(5.02539 1.74158) rotate(15.3369)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoyaLagrangniana);
export default __webpack_public_path__ + "static/media/boya_lagrangniana.fe567551327b7d8b17878f3a8edf781e.svg";
export { ForwardRef as ReactComponent };